export default function Foot() {
  return (
    <div className="side2" id="foot">&nbsp; &nbsp; &nbsp; Ver. 1.9.0 (2025-06-17). &nbsp;
      <a target="_blank" href="https://recoeve.net/">Recoeve.net</a>
       is currently on beta test service stage. Please give us feedbacks, error or errata reports, and suggestions through 
      <a target="_blank" href="https://kipid.tistory.com/entry/Recoeve-net-Feedbacks-Error-reports-and-Suggestions">this blog page (Recoeve.net : Feedbacks, Error reports, and Suggestions)</a>
      .<br />
      <a target="_blank" href="https://kipid.tistory.com/entry/Recoeve-net-3S-Slow-Sexy-Sincere-SNS-%EC%82%AC%EC%9A%A9%EC%84%A4%EB%AA%85%EC%84%9C-Manual">
        Introducing what we are making: Recoeve.net (3S|Slow/Sexy/Sincere SNS) 사용설명서/Manual</a>
    </div>
  );
}
